var TabCustomFieldsModule = /** @class */ (function () {
    function TabCustomFieldsModule() {
    }
    return TabCustomFieldsModule;
}());
export { TabCustomFieldsModule };
